module.exports = __webpack_public_path__ + "img/introbeeld.562a4124.svg";